import styled from 'styled-components';
import BaseAlert from 'component/base/Alert';
import BaseDisableChildren from 'component/base/DisableChildren';

export const Login = styled('div')`
  width: 450px;
  & > * {
    margin-bottom: 24px;
    width: 100%;
  }

  & > *:first-child {
    margin-bottom: 62px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const DisableChildren = styled(BaseDisableChildren)`
  width: 450px;
  & > * {
    margin-bottom: 24px;
    width: 100%;
  }

  & > *:first-child {
    margin-bottom: 0px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const Heading = styled.h1`
  font-family: ClearfaceStd;
  font-weight: bold;
  font-size: 36px;
  color: ${(props) => props.theme.colors.darkBlue};
  text-align: center;
`;

export const Alert = styled(BaseAlert)`
  line-height: 1.5;
`;
